module.exports = __webpack_public_path__ + "static/digital-marketing-sydney-valor-2ad98d46e39b4ba2f3cb8bf728e787d1.png";